<template>
  <div class="custom-nav-tabs">
    <b-tabs v-model="tabIndex" content-class="mt-3">
      <b-tab
        :title="$t('quick-access')"
        v-if="!$store.getters['enums/is_not_permitted']('quickAccess')"
      >
        <section v-if="tabIndex === 0">
          <QuickAccess />
        </section>
      </b-tab>
      <b-tab :title="$t('noc')" v-if="!$store.getters['enums/is_not_permitted']('NOC')">
        <section v-if="tabIndex === 1">
          <Dashboard />
        </section>
      </b-tab>
      <b-tab :title="$t('gps-track')" v-if="!$store.getters['enums/is_not_permitted']('NOC')">
        <section v-if="tabIndex === 2">
          <GPSTrack />
        </section>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Dashboard from '@/components/Dashboard/index.vue'
import GPSTrack from '@/components/GPSTrack/index.vue'
import QuickAccess from '@/components/Dashboard/QuickAccess.vue'

export default {
  name: 'dashboard',
  components: { Dashboard, GPSTrack, QuickAccess },
  data() {
    return { tabIndex: 0 }
  },
}
</script>
